import { SoftSelect } from "@soft-db/ui";
import AuditDateFilterConfiguration from "./AuditDateFilterConfiguration";
import AuditTargetFilterConfiguration from "./AuditTargetFilterConfiguration";
import AuditUserFilterConfiguration from "./AuditUserFilterConfiguration";
import { AuditFilterType, PartialAuditFilter } from "./audit-filter.type";

type AuditTypeSelectItem = {
	value: AuditFilterType;
	text: string;
};
export default defineComponent({
	name: "AuditFIlterItem",
	props: {
		filter: {
			type: Object as PropType<PartialAuditFilter>,
			required: true,
		},
		types: {
			type: Array as PropType<AuditFilterType[]>,
			default: () => [],
		},
	},
	setup(props, { emit }) {
		const { t } = useI18n();

		const filter = useVModel(props, "filter", emit);

		function createTypeSelectItem(type: AuditFilterType) {
			switch (type) {
				case "date":
					return { text: t("common.date"), value: type };
				case "target":
					return { text: t("common.object"), value: type };
				case "user":
					return { text: t("object.user"), value: type };
			}
		}

		const availableTypes = computed<AuditTypeSelectItem[]>(() =>
			[
				createTypeSelectItem(filter.value.type),
				...props.types.map<AuditTypeSelectItem>(createTypeSelectItem),
			].sort((a, b) => a.text.localeCompare(b.text))
		);

		return () => (
			<div class="grid grid-cols-6 gap-2">
				<SoftSelect
					class="col-span-1"
					v-model={filter.value.type}
					items={availableTypes.value}
					label={t("audit.filterType")}
				/>
				<div class="auto-grid col-span-5 gap-2">
					{filter.value.type === "date" ? (
						<AuditDateFilterConfiguration v-model:filter={filter.value} />
					) : filter.value.type === "target" ? (
						<AuditTargetFilterConfiguration v-model:filter={filter.value} />
					) : filter.value.type === "user" ? (
						<AuditUserFilterConfiguration v-model:filter={filter.value} />
					) : undefined}
				</div>
			</div>
		);
	},
});
